import type { JsonValue, ProviderMetadata, ResolutionDetails } from '@openfeature/core'
import { FlagNotFoundError } from '@openfeature/core'
import { Provider } from '@openfeature/react-sdk'

export class InMemoryFlagProvider implements Provider {
    constructor(private readonly values: Partial<Record<string, boolean | string | number>>) {}
    metadata: ProviderMetadata = {
        name: 'in-memory',
    }
    hooks?: undefined

    resolveBooleanEvaluation(flagKey: string, defaultValue: boolean): ResolutionDetails<boolean> {
        return this.resolveAndCheckFlag(flagKey, defaultValue, 'boolean')
    }

    resolveNumberEvaluation(flagKey: string, defaultValue: number): ResolutionDetails<number> {
        return this.resolveAndCheckFlag(flagKey, defaultValue, 'number')
    }

    resolveStringEvaluation(flagKey: string, defaultValue: string): ResolutionDetails<string> {
        return this.resolveAndCheckFlag(flagKey, defaultValue, 'string')
    }

    private resolveAndCheckFlag<T>(flagKey: string, defaultValue: T, typeName: string): ResolutionDetails<T> {
        if (flagKey in this.values) {
            const result = this.values[flagKey]
            if (typeof result !== typeName) {
                throw new FlagNotFoundError(`flag with key ${flagKey} was of type '${typeof result}'; '${typeName}' was requested`)
            }
            return { value: result as T }
        }
        return { value: defaultValue }
    }

    resolveObjectEvaluation<T extends JsonValue>(): ResolutionDetails<T> {
        throw new Error('Method "InMemoryFlagProvider.resolveObjectEvaluation" not implemented.')
    }
}
